// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const MEETINGS = [
  { id: 1, date: "2026-02-10", time: "10:00 AM", client: "Canstorr Commodities", contact: "Mike Thompson", attendees: ["Tyson Becker", "Ryan Miskulin"], type: "Quarterly Review", location: "Zoom", status: "upcoming", notes: "" },
  { id: 2, date: "2026-02-10", time: "2:00 PM", client: "Western Mining Corp", contact: "Sarah Chen", attendees: ["Lee Mehling", "Jordan Lutz"], type: "Demo", location: "Google Meet", status: "upcoming", notes: "" },
  { id: 3, date: "2026-02-11", time: "11:00 AM", client: "Apex Insurance Brokers", contact: "Lisa Nguyen", attendees: ["Lucas Mason", "Taylor Schenher"], type: "Negotiation", location: "In-Person - Apex HQ", status: "upcoming", notes: "" },
  { id: 4, date: "2026-02-12", time: "9:30 AM", client: "Prairie Fleet Services", contact: "Dave Richards", attendees: ["Lucas Mason"], type: "Demo", location: "Zoom", status: "upcoming", notes: "" },
  { id: 5, date: "2026-02-07", time: "3:00 PM", client: "Northern Health Authority", contact: "Jennifer Walsh", attendees: ["Des Bachynski", "Jordan Lutz"], type: "Follow-Up", location: "Teams", status: "past", notes: "Beta feedback very positive. 3 pilot clinics reporting 40% time savings. Discussed scaling to full deployment Q2. Need to resolve data migration concerns." },
  { id: 6, date: "2026-02-05", time: "10:00 AM", client: "HealthFirst Clinics", contact: "Karen Phillips", attendees: ["Des Bachynski", "Ryan Miskulin"], type: "Onboarding", location: "In-Person - HealthFirst Office", status: "past", notes: "Kicked off onboarding for VitaSync. Trained 8 staff members on core workflows. Set up user accounts and custom dashboards. Next check-in Feb 19." },
  { id: 7, date: "2026-02-03", time: "1:00 PM", client: "GreenLeaf Cannabis Co", contact: "Amanda Foster", attendees: ["Lucas Mason"], type: "Discovery", location: "Phone", status: "past", notes: "Amanda outlined compliance requirements. They need seed-to-sale tracking. Budget is $20-25K range. Send follow-up with compliance feature breakdown." },
  { id: 8, date: "2026-02-14", time: "4:00 PM", client: "BeautyBliss Salons", contact: "Priya Sharma", attendees: ["Lucas Mason", "Des Bachynski"], type: "Demo", location: "Zoom", status: "upcoming", notes: "" },
];

const TYPES = ["All", "Demo", "Discovery", "Follow-Up", "Quarterly Review", "Onboarding", "Negotiation"];
const WEEK_DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri"];

export default function ClientMeetingsPage() {
  const [meetings, setMeetings] = useState(MEETINGS);
  const [view, setView] = useState("list");
  const [typeFilter, setTypeFilter] = useState("All");
  const [showAddModal, setShowAddModal] = useState(false);
  const [newMeeting, setNewMeeting] = useState({ date: "", time: "", client: "", contact: "", type: "Demo", location: "" });

  const upcoming = meetings.filter(m => m.status === "upcoming").sort((a, b) => a.date.localeCompare(b.date) || a.time.localeCompare(b.time));
  const past = meetings.filter(m => m.status === "past").sort((a, b) => b.date.localeCompare(a.date));

  const filtered = (list) => typeFilter === "All" ? list : list.filter(m => m.type === typeFilter);

  const typeColor = (type) => {
    const colors = { Demo: "#3b82f6", Discovery: "#8b5cf6", "Follow-Up": "#eab308", "Quarterly Review": "#10b981", Onboarding: "#ec4899", Negotiation: "#f97316" };
    return colors[type] || "#64748b";
  };

  const addMeeting = () => {
    if (!newMeeting.client || !newMeeting.date) return;
    setMeetings(prev => [...prev, { ...newMeeting, id: Date.now(), attendees: [], status: "upcoming", notes: "" }]);
    setNewMeeting({ date: "", time: "", client: "", contact: "", type: "Demo", location: "" });
    setShowAddModal(false);
  };

  // Simple week view: Feb 10-14
  const weekDates = ["2026-02-10", "2026-02-11", "2026-02-12", "2026-02-13", "2026-02-14"];

  return (
    <div>
      <div className="page-header">
        <div><h1>Client Meetings</h1><p>{upcoming.length} upcoming meetings</p></div>
        <div style={{ display: "flex", gap: 8 }}>
          <button className={"btn " + (view === "list" ? "btn-primary" : "btn-outline")} onClick={() => setView("list")}>List</button>
          <button className={"btn " + (view === "calendar" ? "btn-primary" : "btn-outline")} onClick={() => setView("calendar")}>Week View</button>
          <button className="btn btn-primary" onClick={() => setShowAddModal(true)}>+ Schedule Meeting</button>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Upcoming</div><div className="stat-value" style={{ color: "#3b82f6" }}>{upcoming.length}</div></div>
        <div className="stat-card"><div className="stat-label">This Week</div><div className="stat-value">{meetings.filter(m => m.date >= "2026-02-10" && m.date <= "2026-02-14").length}</div></div>
        <div className="stat-card"><div className="stat-label">Past (This Month)</div><div className="stat-value">{past.length}</div></div>
        <div className="stat-card"><div className="stat-label">Most Common Type</div><div className="stat-value" style={{ fontSize: 18, color: "#3b82f6" }}>Demo</div></div>
      </div>

      {/* Type Filter */}
      <div className="card" style={{ display: "flex", gap: 8, padding: "12px 20px", flexWrap: "wrap" }}>
        {TYPES.map(t => (
          <button key={t} className={"btn btn-sm " + (typeFilter === t ? "btn-primary" : "btn-outline")} onClick={() => setTypeFilter(t)}>{t}</button>
        ))}
      </div>

      {view === "list" ? (
        <div>
          {/* Upcoming */}
          <div className="card" style={{ marginTop: 16 }}>
            <div className="card-header"><h3 style={{ color: "#3b82f6" }}>Upcoming Meetings</h3><span className="card-badge" style={{ background: "#3b82f6" }}>{filtered(upcoming).length}</span></div>
            {filtered(upcoming).length === 0 && <div style={{ padding: 16, color: "#64748b", fontSize: 13 }}>No upcoming meetings match this filter.</div>}
            {filtered(upcoming).map(meeting => (
              <div key={meeting.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "14px 0", borderBottom: "1px solid #334155", gap: 16, flexWrap: "wrap" }}>
                <div style={{ minWidth: 90 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#e2e8f0" }}>{meeting.date}</div>
                  <div style={{ fontSize: 13, color: "#10b981", fontWeight: 600 }}>{meeting.time}</div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: "#e2e8f0" }}>{meeting.client}</div>
                  <div style={{ fontSize: 12, color: "#94a3b8" }}>with {meeting.contact}</div>
                  <div style={{ display: "flex", gap: 4, marginTop: 6, flexWrap: "wrap" }}>
                    {meeting.attendees.map(a => <span key={a} style={{ fontSize: 11, padding: "2px 8px", background: "#1e293b", border: "1px solid #334155", borderRadius: 12, color: "#e2e8f0" }}>{a}</span>)}
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <span className="badge" style={{ background: typeColor(meeting.type) + "22", color: typeColor(meeting.type) }}>{meeting.type}</span>
                  <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>{meeting.location}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Past */}
          <div className="card" style={{ marginTop: 16 }}>
            <div className="card-header"><h3 style={{ color: "#64748b" }}>Past Meetings</h3><span className="card-badge">{filtered(past).length}</span></div>
            {filtered(past).map(meeting => (
              <div key={meeting.id} style={{ padding: "14px 0", borderBottom: "1px solid #334155" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 16, flexWrap: "wrap" }}>
                  <div style={{ minWidth: 90 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "#94a3b8" }}>{meeting.date}</div>
                    <div style={{ fontSize: 13, color: "#64748b" }}>{meeting.time}</div>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#e2e8f0" }}>{meeting.client}</div>
                    <div style={{ fontSize: 12, color: "#94a3b8" }}>with {meeting.contact}</div>
                  </div>
                  <span className="badge" style={{ background: typeColor(meeting.type) + "22", color: typeColor(meeting.type) }}>{meeting.type}</span>
                </div>
                {meeting.notes && (
                  <div style={{ marginTop: 8, marginLeft: 106, padding: "10px 14px", background: "#0f172a", borderRadius: 8, borderLeft: "3px solid #334155" }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", marginBottom: 4 }}>Meeting Notes</div>
                    <div style={{ fontSize: 13, color: "#e2e8f0", lineHeight: 1.6 }}>{meeting.notes}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        /* Calendar Week View */
        <div className="card" style={{ marginTop: 16 }}>
          <div className="card-header"><h3>Week of Feb 10 - 14, 2026</h3></div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 1, background: "#334155" }}>
            {WEEK_DAYS.map((day, i) => (
              <div key={day} style={{ background: "#1e293b" }}>
                <div style={{ padding: "8px 12px", textAlign: "center", borderBottom: "2px solid #334155" }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#94a3b8" }}>{day}</div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: "#e2e8f0" }}>Feb {10 + i}</div>
                </div>
                <div style={{ padding: 8, minHeight: 150 }}>
                  {meetings.filter(m => m.date === weekDates[i]).map(meeting => (
                    <div key={meeting.id} style={{ padding: "8px 10px", background: typeColor(meeting.type) + "15", border: "1px solid " + typeColor(meeting.type) + "33", borderRadius: 6, marginBottom: 6 }}>
                      <div style={{ fontSize: 11, fontWeight: 700, color: typeColor(meeting.type) }}>{meeting.time}</div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: "#e2e8f0", marginTop: 2 }}>{meeting.client}</div>
                      <div style={{ fontSize: 10, color: "#94a3b8" }}>{meeting.type}</div>
                    </div>
                  ))}
                  {meetings.filter(m => m.date === weekDates[i]).length === 0 && (
                    <div style={{ fontSize: 12, color: "#334155", textAlign: "center", paddingTop: 40 }}>No meetings</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Add Meeting Modal */}
      {showAddModal && (
        <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Schedule Meeting</h2>
              <button className="modal-close" onClick={() => setShowAddModal(false)}>X</button>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-field"><label>Date</label><input className="input" type="date" value={newMeeting.date} onChange={e => setNewMeeting({ ...newMeeting, date: e.target.value })} /></div>
                <div className="form-field"><label>Time</label><input className="input" value={newMeeting.time} onChange={e => setNewMeeting({ ...newMeeting, time: e.target.value })} placeholder="e.g. 2:00 PM" /></div>
              </div>
              <div className="form-row">
                <div className="form-field"><label>Client / Company</label><input className="input" value={newMeeting.client} onChange={e => setNewMeeting({ ...newMeeting, client: e.target.value })} placeholder="Company name" /></div>
                <div className="form-field"><label>Contact Person</label><input className="input" value={newMeeting.contact} onChange={e => setNewMeeting({ ...newMeeting, contact: e.target.value })} placeholder="Contact name" /></div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Meeting Type</label>
                  <select value={newMeeting.type} onChange={e => setNewMeeting({ ...newMeeting, type: e.target.value })} style={{ padding: "8px 12px", background: "#0f172a", border: "1px solid #334155", borderRadius: 6, color: "#e2e8f0", width: "100%" }}>
                    {TYPES.slice(1).map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
                <div className="form-field"><label>Location / Link</label><input className="input" value={newMeeting.location} onChange={e => setNewMeeting({ ...newMeeting, location: e.target.value })} placeholder="Zoom, In-Person, etc." /></div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline" onClick={() => setShowAddModal(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={addMeeting}>Schedule</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
